export var getDropdownPosition = function (containerRef) {
    var _a;
    var documentBodyHeight = document.body.getBoundingClientRect().height;
    var rect = (_a = containerRef.current) === null || _a === void 0 ? void 0 : _a.getBoundingClientRect();
    if (rect) {
        var inputPositionBottom = rect.bottom;
        var inputPositionTop = rect.top;
        var dropDownHeight = 360;
        if (inputPositionBottom + dropDownHeight >= documentBodyHeight &&
            inputPositionTop > dropDownHeight) {
            return 'top';
        }
        else {
            return 'bottom';
        }
    }
    else {
        return 'bottom';
    }
};
